import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { EmployeeExitClearanceVm } from '../models/requests/ExitClearanceRequestVM';
import { ExitClearanceDto } from '../models/ExitClearanceDto';
import { PendingExitApprovalModel } from '../models/PendingExitApprovalModel';
import { ExitClearanceApprovalDto } from '../models/ExitClearanceApprovalDto';
import { approveMovementVm } from '../models/approveMovementVm';
import { ApproveContractWithTokenDto } from '../models/ApproveContractWithTokenDto';
import { ConfirmExitClearanceWithToken } from '../models/ConfirmExitClearanceWithDto';

@Injectable({
  providedIn: 'root'
})
export class ExitClearanceService {

  constructor(private httpClient: HttpClient) { }

  saveNewExitClearance(exitClearanceRequest: EmployeeExitClearanceVm): Observable<ApiResponseObject<ExitClearanceDto>> {
    ;
    return this.httpClient.post<ApiResponseObject<ExitClearanceDto>>(`${environment.apiUrl}/EmployeeExitClearances/CreateEmployeeExitClearanceForm`, exitClearanceRequest);
  }
  crateExitform(newmovementRequest: EmployeeExitClearanceVm): Observable<ApiResponseObject<ExitClearanceDto>> {
    ;
    return this.httpClient.post<ApiResponseObject<ExitClearanceDto>>(`${environment.apiUrl}/EmployeeExitClearances/CreateEmployeeExitClearanceForm`, newmovementRequest);
  }

  getPendingApproval(): Observable<ApiResponseObject<PendingExitApprovalModel[]>> {
    return this.httpClient.get<ApiResponseObject<PendingExitApprovalModel[]>>(`${environment.apiUrl}/EmployeeExitClearances/GetMyPendingClearanceForApproval`);
  }

  getExitClearanceForms(): Observable<ApiResponseObject<PendingExitApprovalModel[]>> {
    return this.httpClient.get<ApiResponseObject<PendingExitApprovalModel[]>>(`${environment.apiUrl}/EmployeeExitClearances/GetMyExitClearanceForm`);
  }

  getAllExitClearanceForms(): Observable<ApiResponseObject<PendingExitApprovalModel[]>> {
    return this.httpClient.get<ApiResponseObject<PendingExitApprovalModel[]>>(`${environment.apiUrl}/EmployeeExitClearances/GetAllExitClearance`);
  }
  GetExitClearanceApproval(): Observable<ApiResponseObject<ExitClearanceApprovalDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ExitClearanceApprovalDto[]>>(`${environment.apiUrl}/EmployeeExitClearances/GetAllExitClearanceApprover`);
  }
  GetExitClearanceApprovalByClearance(id:number): Observable<ApiResponseObject<ExitClearanceApprovalDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ExitClearanceApprovalDto[]>>(`${environment.apiUrl}/EmployeeExitClearances/GetExitClearanceApprovalByClearance/${id}`);
  }
  approve(approverequest: approveMovementVm): Observable<ApiResponseObject<ExitClearanceApprovalDto>> {
    ;
    return this.httpClient.post<ApiResponseObject<ExitClearanceApprovalDto>>(`${environment.apiUrl}/EmployeeExitClearances/Approve`, approverequest);
  }
  feedback(approverequest: {id: number, message: string}): Observable<ApiResponseObject<ExitClearanceApprovalDto>> {
    ;
    return this.httpClient.post<ApiResponseObject<ExitClearanceApprovalDto>>(`${environment.apiUrl}/EmployeeExitClearances/Feedback`, approverequest);
  }
  GetMyPendingAuthorisation(): Observable<ApiResponseObject<PendingExitApprovalModel[]>> {
    return this.httpClient.get<ApiResponseObject<PendingExitApprovalModel[]>>(`${environment.apiUrl}/EmployeeExitClearances/GetMyPendingAuthorisation`);
  }

  AuthorizeClearance(approverequest: approveMovementVm): Observable<ApiResponseObject<ExitClearanceApprovalDto>> {
    ;
    return this.httpClient.post<ApiResponseObject<ExitClearanceApprovalDto>>(`${environment.apiUrl}/EmployeeExitClearances/AuthorizeClearance`, approverequest);
  }

  UpdateApprover(requestBody: { id: number, userId: string }): Observable<ApiResponseObject<boolean>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/EmployeeExitClearances/UpdateApprover`, requestBody);
  } 
  UpdateApproverByClearanceId(requestBody: { exitClearanceId: number, description: string, userId: string }): Observable<ApiResponseObject<boolean>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/EmployeeExitClearances/UpdateApproverByExitClearanceId`, requestBody);
  }

  SendReminder(exitClearanceId: number): Observable<ApiResponseObject<boolean>> {  
    ;
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/EmployeeExitClearances/SendReminderEmail/${exitClearanceId}`, exitClearanceId);
  } 

  SendReminderByEmployee(exitClearanceId: number): Observable<ApiResponseObject<boolean>> {  
    ;
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/EmployeeExitClearances/SendReminderEmailByEmployee/${exitClearanceId}`, exitClearanceId);
  }

   BeginApproval(token: string): Observable<ApiResponseObject<ConfirmExitClearanceWithToken>> {
      return this.httpClient.get<ApiResponseObject<ConfirmExitClearanceWithToken>>(`${environment.apiUrl}/EmployeeExitClearances/BeginApproval/${token}`);
    }

  confirmClearanceWithToken(request: {Token: string}): Observable<ApiResponseObject<PendingExitApprovalModel>> {
    
    return this.httpClient.post<ApiResponseObject<PendingExitApprovalModel>>(`${environment.apiUrl}/EmployeeExitClearances/EmployeeAuthorizeWithToken`, request );
  }
  UpdateWaiverRequest(request: {Token: string}, reason: string): Observable<ApiResponseObject<PendingExitApprovalModel>> {
    
    return this.httpClient.post<ApiResponseObject<PendingExitApprovalModel>>(`${environment.apiUrl}/EmployeeExitClearances/SendDrEmpOption/${reason}`, request );
  }

  downloadClearance(id: number) {
    const url = `${environment.apiUrl}/EmployeeExitClearances/download/${id}`;
    this.httpClient.get(url, { responseType: 'blob' }).subscribe(response => {
      const blob = new Blob([response], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `Clearance_${id}.pdf`;
      link.click();
    });
  }
  
  viewClearance(id: number) {
    const url = `${environment.apiUrl}/EmployeeExitClearances/view/${id}`;
    window.open(url, '_blank'); 
  }
  
   UnApprove(requestBody: { id: number, message: string }): Observable<ApiResponseObject<boolean>> {
    ;
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/EmployeeExitClearances/UnApprove`, requestBody);
  } 
}
